module.exports = __webpack_public_path__ + "static/media/logo_a2design_black.6a2eecb3.png";